import React, { Component } from 'react'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import LinkExpandable from '../linkExpandable'

class VenuesExpandable extends Component {
  static propTypes = {
    elmId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
    event: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    // Automatically opens venue tab when venue is specified by query param
    this.state = {
      expanded: !!get(props.event, 'query.selected_venue_id'),
    }
  }

  toggleExpand = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const { elmId, className, children } = this.props
    return (
      <div className={className}>
        <LinkExpandable
          elmId={elmId + '_venues_expandable'}
          expanded={this.state.expanded}
          toggleExpand={this.toggleExpand}
          title='Event Times And Locations'
        />
        {this.state.expanded && children}
      </div>
    )
  }
}

export default VenuesExpandable
